import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { UtensilsCrossed } from "lucide-react";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login", { replace: true }); return; }
    const sid = decodeURIComponent(m[1]);
    (async () => {
      try {
        const { data } = await api.post("/auth/session", null, { headers: { "X-Session-ID": sid } });
        setUser(data.user);
        const roleHome = { admin: "/dashboard", reception: "/tickets", tickets: "/scan" };
        const target = roleHome[data.user.role] || "/dashboard";
        window.history.replaceState(null, "", target);
        nav(target, { replace: true });
      } catch (e) {
        const detail = e?.response?.data?.detail;
        if (detail) {
          const msg = encodeURIComponent(typeof detail === "string" ? detail : "Google sign-in rejected");
          nav(`/login?error=${msg}`, { replace: true });
        } else {
          console.error("Emergent auth failed", formatApiError(e));
          nav("/login", { replace: true });
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0B1120]">
      <div className="flex flex-col items-center gap-4 text-slate-300">
        <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-orange-500 to-rose-500 flex items-center justify-center animate-pulse">
          <UtensilsCrossed className="text-white" size={26} />
        </div>
        <div className="font-display text-2xl font-black tracking-tight">Signing you in…</div>
      </div>
    </div>
  );
}
